"use client";

import { RiAlertLine, RiRefreshLine } from "@remixicon/react";
import { Button } from "@workspace/ui/components/button";
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "@workspace/ui/components/card";
import { useEffect } from "react";

interface GlobalErrorProps {
	error: Error & { digest?: string };
	reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
	useEffect(() => {
		console.error("Global error:", error);
	}, [error]);

	return (
		<html lang="en">
			<body>
				<div className="flex min-h-screen items-center justify-center bg-background p-4">
					<Card className="w-full max-w-md">
						<CardHeader className="text-center">
							<div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
								<RiAlertLine className="h-6 w-6 text-destructive" />
							</div>
							<CardTitle>Application Error</CardTitle>
						</CardHeader>
						<CardContent className="space-y-4">
							<p className="text-center text-muted-foreground text-sm">
								We've encountered an unexpected error. Our team has been
								notified and is working to resolve this issue.
							</p>

							<Button onClick={reset} className="w-full" variant="outline">
								<RiRefreshLine className="mr-2 h-4 w-4" />
								Try again
							</Button>
						</CardContent>
					</Card>
				</div>
			</body>
		</html>
	);
}